import axios from "axios";
import { SelectFormat } from "../../../rbts/helpers/models/GenericModel";
const API_URL = process.env.REACT_APP_API;

export async function reporteCortesias(id_dia: number) {
    try {
      const response = await axios.get(`${API_URL}cortesias/getByDia/${id_dia}`);
      const data = response.data.doc.data;
      return data;
    } catch (err) {
      console.error("Error al actualizar el precio:", err);
      throw err;
    }
  }

  export async function reporteVentas(ids_dia: number[], id_caja: number, nombreProducto: string) {
    try {
      const params = new URLSearchParams();

      if (ids_dia && ids_dia.length > 0) {
        params.append('ids_dia', ids_dia.join(','));
      }
      if (id_caja) {
        params.append('caja_id', id_caja.toString());
      }
      if (nombreProducto) {
        params.append('product_name', nombreProducto.toString());
      }
      const response = await axios.get(`${API_URL}ventas/cajas/dia_venta?${params.toString()}`);
      const data = response.data.doc.data;
      return data;
    } catch (err) {
      console.error("Error al actualizar el precio:", err);
      throw err;
    }
  }

  export async function obtenerDiasPorEvento() {  
    try {
      const response = await axios.get(`${API_URL}/diaventa/event`);
      const data = response.data.doc.data;
      let select: SelectFormat[] = [];
      data.forEach((item: any) => {
        const selectCustom = {
          id: Number(item.id),
          value: item.id,
          label: `${item.fecha}`,
          data: item,
        };
        select.push(selectCustom);
      });

      return select;
    } catch (err) {
      console.error("Error al obtener los días por evento:", err);
      throw err;
    }
  }